import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import EducationalTopics from "./pages/EducationalTopics";
import Article from "./pages/Article";
import AITestGeneration from "./pages/AITestGeneration";
import "./index.css";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen antialiased">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/educational-topics" element={<EducationalTopics />} />
            <Route path="/open-source-tools" element={<Article />} />
            <Route path="/article" element={<Article />} />
            <Route path="/ai-test-generation" element={<AITestGeneration />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
